import { stripUnit } from 'polished';
import React from 'react';
import { animated, useTransition } from 'react-spring';
import styled from 'styled-components';
import theme from 'ui/theme';
import { e2e } from 'utils/queryUtils';
import { isMobile } from 'utils/platform';

const MobileDrawer = styled.div`
  position: fixed;
  bottom: 0;
  height: 80vh;
  width: 100%;
  background: white;
  z-index: 20;
  border-radius: 10px 10px 0 0;
  transform: translateY(110%);
  transition: transform 0.3s ease-out;
  box-shadow: 0 -4px 16px 0 #00000140;

  &[data-open='true'] {
    transform: translateY(0);
  }
`;

const SlideoutMenu = styled(animated.div)`
  top: ${theme.layout.headerHeight};
  right: 0;
  position: fixed;
  width: ${theme.layout.sidebarWidth};
  height: calc(100vh - ${theme.layout.headerHeight});
  background: white;
  z-index: 201;
`;

type Props = {
  trigger: boolean;
  children: React.ReactNode;
};

const SlideOutMenu = ({ children, trigger }: Props) => {
  const selectedMenuTransition = useTransition(trigger, {
    from: {
      x: stripUnit(theme.layout.sidebarWidth)
    },
    enter: { x: 0 },
    leave: {
      x: stripUnit(theme.layout.sidebarWidth)
    },
    unique: true
  });

  if (isMobile()) {
    return <MobileDrawer data-open={trigger}>{children}</MobileDrawer>;
  }

  return (
    <>
      {selectedMenuTransition(
        (style, item, { key }) =>
          item && (
            <SlideoutMenu
              key={key}
              style={
                e2e()
                  ? undefined
                  : {
                      transform:
                        style && style.x.to((x: number) => (x ? `translateX(${x}rem)` : 'none'))
                    }
              }
            >
              {children}
            </SlideoutMenu>
          )
      )}
    </>
  );
};

export default SlideOutMenu;
